import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, MapPin } from 'lucide-react';
const nombres = ['Camila', 'Luciana', 'Valentina', 'Sofía', 'Martina', 'Florencia', 'Agustina', 'Milagros', 'Rocío', 'Julieta', 'Carolina', 'Paula', 'Daniela', 'María', 'Andrea', 'Belén', 'Natalia', 'Romina', 'Celeste', 'Micaela', 'Aldana', 'Brenda', 'Yanina', 'Soledad', 'Tamara', 'Gimena', 'Lorena', 'Mariana', 'Silvina', 'Gabriela'];
const zonas = ['CABA', 'La Plata', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Mar del Plata', 'Salta', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'San Luis', 'Paraná', 'Formosa', 'Corrientes', 'Río Gallegos', 'Ushuaia', 'San Rafael', 'Zona Norte GBA', 'Zona Sur GBA', 'Zona Oeste GBA', 'Quilmes', 'Morón', 'Lanús', 'Pilar', 'Tigre', 'San Isidro', 'Avellaneda'];
const ofertas = ['Stretching Resuelto', 'Stretching Resuelto + Cuerpo Seguro Pro™'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomInterval() {
  return (Math.floor(Math.random() * 31) + 40) * 1000; // 40-70 seconds
}
export function SocialProofToast() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    nombre: '',
    zona: '',
    oferta: ''
  });
  const showToast = useCallback(() => {
    setData({
      nombre: getRandom(nombres),
      zona: getRandom(zonas),
      oferta: getRandom(ofertas)
    });
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 4500);
  }, []);
  useEffect(() => {
    // Show first toast after 15-25 seconds
    const initialDelay = setTimeout(() => {
      showToast();
    }, (Math.floor(Math.random() * 11) + 15) * 1000);
    return () => clearTimeout(initialDelay);
  }, [showToast]);
  useEffect(() => {
    if (!visible) {
      const nextTimeout = setTimeout(() => {
        showToast();
      }, getRandomInterval());
      return () => clearTimeout(nextTimeout);
    }
  }, [visible, showToast]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm" data-id="element-305">
      <AnimatePresence data-id="element-306">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} className="bg-[#0f2a36] border border-brand-accent/30 rounded-xl p-3.5 shadow-[0_8px_32px_rgba(0,0,0,0.4)] backdrop-blur-sm" data-id="element-307">
            <div className="flex items-start gap-3" data-id="element-308">
              <div className="w-9 h-9 rounded-full bg-brand-accent/20 flex items-center justify-center shrink-0" data-id="element-309">
                <ShoppingBag className="w-4 h-4 text-brand-accent" data-id="element-310" />
              </div>
              <div className="min-w-0" data-id="element-311">
                <p className="text-white text-sm font-semibold leading-snug" data-id="element-312">
                  {data.nombre} compró{' '}
                  <span className="text-brand-accent" data-id="element-313">{data.oferta}</span>
                </p>
                <p className="text-gray-400 text-xs mt-1 flex items-center" data-id="element-314">
                  <MapPin className="w-3 h-3 mr-1 shrink-0" data-id="element-315" />
                  {data.zona}, Argentina · hace unos minutos
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}